/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/accordion.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/accordion.js'

import './styles.scss'
import './main.scss'

import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { InfoSection } from '../InfoSection'
import { ListSection } from '../ListSection'

import { render } from 'enzyme'

// TODO Set the correct article ID here
const ARTICLE_ID = '356669065603'

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead inverted articleId={ARTICLE_ID} />
      <ThemeSwitch />
      <header className='ui vertical very fitted segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>So wähle ich wirklich smart</h1>
            <h2>
              Kumulieren, panaschieren, streichen oder gleich eine neue Liste
              beginnen? Die «Bund»-Wahlhilfe zeigt Ihnen auch 2020, wie Sie
              Ihren Willen am besten auf den Wahlzettel bringen – und spart
              nicht mit fiesen Tricks.
            </h2>
          </div>
        </div>
      </header>
      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta metainfo'>
            <div className='ta author'>Dölf Barben, Christian Zellweger</div>
            <div className='ta updated'>Aktualisiert am 6. November 2020</div>
          </div>
          <div className='ta text'>
            <p>
              Wie kann ich eine Kandidatin auf die Überholspur stellen und ihren
              Konkurrenten ausbremsen? Wann ist es sinnvoll, einen Kandidaten zu
              kumulieren, wann ist es besser, ihn zu streichen? Gibt es Tricks –
              fies, aber noch legal –, mit denen ich den politischen Gegner dazu
              bringen kann, aus meiner Sicht «richtig» zu wählen?
            </p>
            <p>
              Dieses Tool will jede Berner Wählerin und jeden Berner Wähler dazu
              ermächtigen, die ureigenen Interessen mit hohem Wirkungsgrad in
              wuchtige Stimmkraft umzuwandeln. Wer das System durchschaut, ist
              nicht mehr auf fadenscheinige Ratschläge von Parteien und
              Kandidaten angewiesen, er bearbeitet den eigenen Wahlzettel
              gezielt und lustvoll – statt ihn unverändert oder gar nicht
              einzuwerfen.
            </p>
          </div>
        </div>
      </div>
      <InfoSection />
      <div className='ui vertical segment lists'>
        <ListSection />
      </div>
      <Footer
        hidePortfolioTeaser
        mailTo='bern@derbund.ch'
        articleId={ARTICLE_ID}
        credits={[
          ['Text, Umsetzung', 'Christian Zellweger'],
          ['Text, Idee', 'Dölf Barben'],
          ['Leitung Redaktion Bern', 'Marcello Odermatt']
        ]}
      />
    </div>
  )
}
